/**
 * Created by olga on 21.09.2026
 */

const GeneratorBoosterComponent = function (unit, type) {
    UnitComponent.call(this, unit);

    this.type = type;
};

GeneratorBoosterComponent.prototype = Object.create(UnitComponent.prototype);
GeneratorBoosterComponent.prototype.constructor = GeneratorBoosterComponent;

GeneratorBoosterComponent.prototype.getCharges = function () {
    return this.unit.getData()[this.type].charges;
};

GeneratorBoosterComponent.prototype.getDescription = function () {
    return GeneratorBoosterComponent.TYPES[this.type].description;
};

GeneratorBoosterComponent.prototype.onWrongTarget = function () {
    Merge2.current.showHint(this.unit.onGetView(), Messages.get(GeneratorBoosterComponent.TYPES[this.type].wrongTarget));
};

GeneratorBoosterComponent.prototype.handleDragStart = function () {
    if (this.view) {
        this.view.highlightDrag();
    }
};

GeneratorBoosterComponent.prototype.handleDragMove = function (rawX, rawY, handled) {
    const affected = handled ? undefined : this.findAffectedUnit(rawX, rawY, true);

    if (affected !== this.highlightedTarget) {
        this.unhighlightTarget();

        if (affected) {
            this.highlightedTarget = affected;
            affected.findComponent(MergeComponent).startMergeHighlight();
        }
    }

    return Boolean(affected);
};

GeneratorBoosterComponent.prototype.unhighlightTarget = function () {
    const target = this.highlightedTarget;
    this.highlightedTarget = undefined;

    if (target) {
        target.findComponent(MergeComponent).stopHighlight();
    }
};

GeneratorBoosterComponent.prototype.handleDragEnd = function (rawX, rawY, cancelled) {
    this.unHighlightDrag();
    this.unhighlightTarget();

    const affected = this.findAffectedUnit(rawX, rawY, cancelled);

    if (affected && !cancelled) {
        this.apply(affected);
        this.unit.resetDrag();
        return true;
    }
};

GeneratorBoosterComponent.prototype.unHighlightDrag = function () {
    if (this.view) {
        this.view.unHighlightDrag();
    }
};

GeneratorBoosterComponent.prototype.isAffectedUnit = function (unit) {
    return this.isApplicable(unit);
};

GeneratorBoosterComponent.prototype.isApplicable = function (unit) {
    const generator = unit.findComponent(Merge2Generator);
    if (!generator || Unit.isSideQuest(unit.code) || unit.isGrounded() || unit.isBlocked()) {
        return false;
    }

    return !GeneratorBoosterComponent.TYPES[this.type].energyOnly || Boolean(generator.data.energy);
};

GeneratorBoosterComponent.prototype.apply = function (target) {
    const charges = this.getCharges();

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BOOSTER_USE}-${this.unit.code}`, { itemId: target.code, value: charges });
    cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.BOOSTER_USE_DAU}-${this.unit.code}`);

    target.findComponent(Merge2Generator).addBooster(this.type, charges);

    this.unit.onDestruction();
    this.unit.remove(true);
};

GeneratorBoosterComponent.prototype.handleRemove = function () {
    this.unHighlightDrag();
    this.unhighlightTarget();
};

GeneratorBoosterComponent.prototype.destructor = function () {
    this.unHighlightDrag();
    this.unhighlightTarget();
};

GeneratorBoosterComponent.TYPES = {
    amplifier: {
        description: "UnitInfoView.AmplifierDescription",
        wrongTarget: "Amplifier.wrongTarget"
    },

    energycard: {
        description: "UnitInfoView.EnergyCardDescription",
        wrongTarget: "EnergyCard.wrongTarget",
        energyOnly: true
    }
};
